import { render } from "./autoSubmittedInput.vue?vue&type=template&id=1961d830"
import script from "./autoSubmittedInput.vue?vue&type=script&lang=js"
export * from "./autoSubmittedInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__